<template>

  <!-- TABLE -->
  <tr
  :class="[{'selected': selected[item.tempID]}, {'active-colored': isActiveRow}]">
    <td class="sticky">

      <v-row>
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
                <json-viewer :item="item"></json-viewer>
              </span>
            </div>
          </v-card>
        </v-menu>

        <v-icon 
        class="drag-handle" color="">menu</v-icon>

        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.tempID" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>

        <v-layout align-center>
          <v-btn
          icon
          @click.stop="$emit('checkRow', item)">
            <v-icon> 
              {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
            </v-icon>
          </v-btn>
          <img class="mr-3" src="@/assets/img/illustrations/cardboard-box.png" height="40px" width="40px" />
          {{ item.ordering + 1 }}
          <!--
          <span 
          class=""
          v-html="highlightedID">
          </span>
          -->
        </v-layout>
      </v-row>
    </td>
    <td>
      <template v-if="boxItems.length">
        <div>
          {{ boxItems.length }} items
        </div>
        <div>
          <c-ms-ii
          sid="si-mass-g"
          :realValue="totalWeight"
          labelMode
          class="caption"
          ></c-ms-ii>
        </div>
      </template>
      <template v-else>
        <span class="caption red--text">empty</span>
      </template>
    </td>
    <td>
      <v-row class="caption">
        <v-spacer></v-spacer>
        <v-icon v-if="isActiveRow" color="color1">mdi-chevron-right</v-icon>
      </v-row>
    </td>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props:['item', 'itemsMeta', 'saleItems', 'activeBox', 'searchTextID', 'selected'],
  components: {
    JsonViewer
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    isActiveRow () {
      return this.activeBox === this.item.tempID
    },
    boxItems () {
      return this.saleItems.filter(item => item.box === this.item.tempID)
    },
    totalWeight () {
      return this.boxItems.reduce((a, i) => a + i.weight, 0)
    },
    itemMap () {
      var map ={}
      this.items.forEach(item => {
        if (!map[item.inventory_item_id]) {
          map[item.inventory_item_id] = {
            definition: item.definition,
            items: [item]
            }
        } else {
          map[item.inventory_item_id].items.push(item)
        }
      })
      return map
    },
    highlightedID () {
      var replacedStr = (this.searchTextID || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.ordering.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="green--text">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">

</style>